import { useClientStore } from "@/store/client";
import { useMagasinStore } from "@/store/magasin";
import { usePanierStore } from "@/store/panier";
import { useCheckoutStore } from "@/store/checkout";
import dateUtils from "@/utils/date";

export const pageCommanderConfirmationOkProps = () => ({
  commande: {
    type: Object,
    required: true
  }
})

export const usePageCommanderConfirmationOk = (props) => {

  const magasinStore = useMagasinStore();
  const panierStore = usePanierStore();
  const clientStore = useClientStore();
  const checkoutStore = useCheckoutStore();

  const { isEligibleAbonnementLad, montantMinimumLAD, magasin, getServiceById, name: magasinName, id: magasinId } = storeToRefs(magasinStore);
  const { paniersGroupedByTypePanier, montantTotalByTypePanier } = storeToRefs(panierStore);
  const { isPorteurCarteCora, isPorteurCarteMalin, abonnements, isEligibleDefis} = storeToRefs(clientStore);
  const { setStepValue, setTypePanier } = checkoutStore;

  const service = computed(() => {
    return getServiceById.value(props.commande.data.attributes.service_id);
  })
  const adresse = computed(() => {
    if (props.commande.data.attributes.adresse_retrait) {
      return `${props.commande.data.attributes.adresse_retrait.adresse} 
 ${props.commande.data.attributes.adresse_retrait.cp} 
 ${props.commande.data.attributes.adresse_retrait.ville}`
    } else {
      return `${props.commande.data.attributes.adresse.adresse} 
 ${props.commande.data.attributes.adresse.code_postal} 
 ${props.commande.data.attributes.adresse.ville}`
    }
  })
  const calendarOptions = computed(() => {
    if (service.value) {
      return {
        title: `[coradrive] ${service.value.mode_commande_libelle} commande ${props.commande.data.attributes.code}`,
        start: dateUtils.toDate(props.commande.data.attributes.date_de_retrait),
        duration: 120,
        address: adresse.value,
        end: dateUtils.toDate(props.commande.data.attributes.date_de_retrait_max),
        description: "Toute l'équipe coradrive vous remercie pour votre commande."
      }
    }
  })
  const abonnementInCurrentMagasin = computed(() => {
    if (abonnements.value === null) {
      return null;
    }
    return (
      abonnements.value.find(
        (abo) => abo.attributes.magasin_id === magasinId.value
      ) || null
    );
  })

  const created = () => {
    setStepValue(3);
    setTypePanier(props.commande.data.attributes.type_panier);
  }

  return {
    isEligibleAbonnementLad,
    montantMinimumLAD,
    magasin,
    getServiceById,
    magasinName,
    magasinId,
    paniersGroupedByTypePanier,
    montantTotalByTypePanier,
    isPorteurCarteCora,
    isPorteurCarteMalin,
    isEligibleDefis,
    abonnements,
    service,
    adresse,
    calendarOptions,
    abonnementInCurrentMagasin,
    created
  }
}